import { createContext } from 'react';

export const LoaderContext = createContext<Partial<any>>({show: false});
